export default __webpack_public_path__ + "static/media/escalier.19a42985.png";